import React from 'react';
import Lottie from 'lottie-react';
import animaStatisticData from '../../assets/data/statistic.json';
import './AniStatistic.css';

const AniStatistic = () => {
  return (
    <div className="statistic__box">
      <Lottie animationData={animaStatisticData} loop={true} autoplay={true} />
    </div>
  );
};

export default AniStatistic;
